import React from 'react';
import { render } from 'preact';
import { BaseComponent } from 'project/general';
import {AskAshWidget} from "../ask-ash";

class AskAshWizardComponent extends BaseComponent {

    static getNamespace() {
        return 'ask-ash-wizard';
    }

    static getRequiredRefs() {
        return [
            'dynamicPlaceholder',
            'title',
            'description',
            'titleWhenOpen',
            'descriptionWhenOpen',
            'urgentHelpContent',
            'variant'];
    }


    onInit() {
        this.render();
    }

    render() {
        render(
            <div>
                <AskAshWidget title={this.refs.title.value}
                    description={this.refs.description.value}
                    titleWhenOpen={this.refs.titleWhenOpen.value}
                    descriptionWhenOpen={this.refs.descriptionWhenOpen.value}
                    urgentHelpContent={this.refs.urgentHelpContent.value}
                    variant={this.refs.variant.value}
                    stepElement={this.getElement()}
                >
                </AskAshWidget>
            </div>,
            this.refs.dynamicPlaceholder
        );
    }
}

export default AskAshWizardComponent;
